export default __webpack_public_path__ + "static/media/cai_walk.4bc5b7ce.gif";